import { render } from "./master-pdf-contract.vue?vue&type=template&id=6a6c0c0b"
import script from "./master-pdf-contract.vue?vue&type=script&lang=js"
export * from "./master-pdf-contract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__